import React from 'react';
import { Ticket } from 'lucide-react';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
export function MyTripsPage() {
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-245">
      <div className="bg-white sticky top-0 z-30 shadow-sm px-4 py-4" data-id="element-246">
        <h1 className="font-bold font-bengali text-xl" data-id="element-247">আমার ট্রিপ</h1>
      </div>

      <div className="p-4 space-y-4" data-id="element-248">
        {/* Upcoming Trip */}
        <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm" data-id="element-249">
          <div className="flex justify-between items-start mb-4" data-id="element-250">
            <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold font-bengali" data-id="element-251">
              আসন্ন ট্রিপ
            </div>
            <p className="font-mono text-gray-400 text-sm" data-id="element-252">#TK8392</p>
          </div>

          <div className="flex items-center space-x-4 mb-4" data-id="element-253">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center text-blue-600" data-id="element-254">
              <Ticket size={24} data-id="element-255" />
            </div>
            <div data-id="element-256">
              <h3 className="font-bold text-lg font-bengali" data-id="element-257">ঢাকা ➝ ভোলা</h3>
              <p className="text-gray-500 text-sm font-bengali" data-id="element-258">
                ১৫ মার্চ, ২০২৪ • সকাল ০৮:০০
              </p>
            </div>
          </div>

          <button className="w-full py-2.5 border-2 border-blue-600 text-blue-600 rounded-xl font-bold font-bengali hover:bg-blue-50" data-id="element-259">
            টিকিট দেখুন
          </button>
        </div>

        {/* Past Trip */}
        <div className="bg-white p-5 rounded-2xl border border-gray-200 shadow-sm opacity-75" data-id="element-260">
          <div className="flex justify-between items-start mb-4" data-id="element-261">
            <div className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold font-bengali" data-id="element-262">
              সম্পন্ন
            </div>
            <p className="font-mono text-gray-400 text-sm" data-id="element-263">#TK1120</p>
          </div>

          <div className="flex items-center space-x-4" data-id="element-264">
            <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-gray-500" data-id="element-265">
              <Ticket size={24} data-id="element-266" />
            </div>
            <div data-id="element-267">
              <h3 className="font-bold text-lg font-bengali" data-id="element-268">সিলেট ➝ ঢাকা</h3>
              <p className="text-gray-500 text-sm font-bengali" data-id="element-269">
                ১০ জানুয়ারি, ২০২৪
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}